<mat-sidenav-container class="sidenav-container" [hasBackdrop]="true">
  <mat-sidenav #filterSidenav position="end" mode="over" [fixedInViewport]="true" [fixedTopGap]="0" [fixedBottomGap]="0">
    <app-request-filter-sidenav
      [departmentTypes]="departmentTypes"
      [categories]="categories"
      [subcategories]="subcategories"
      [statusTypes]="statusTypes"
      [users]="users"
      [currentFilters]="filters"
      [savedFilters]="savedFilters"
      (filterChanged)="onFilterChanged($event)"
      (saveFilter)="onSaveFilter($event)"
      (deleteFilter)="onDeleteFilter($event)"
      (loadFilter)="onLoadFilter($event)"
      (close)="filterSidenav.close()">
    </app-request-filter-sidenav>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="view-controls">
      <div class="view-tabs">
        <div class="tab" [class.active]="activeView === 'list'" (click)="toggleView('list')">{{ 'request_v2.list.view_list' | translate }}</div>
        <div class="tab" [class.active]="activeView === 'map'" (click)="toggleView('map')">{{ 'request_v2.list.view_map' | translate }}</div>
      </div>

    
     
      <div class="filter-export-buttons">
        <div class="search-container">
          <mat-icon class="search-icon">search</mat-icon>
          <input 
            type="text" 
            [formControl]="searchControl" 
            [placeholder]="'request_v2.list.search_placeholder' | translate"
            class="search-input"
          >
          <mat-icon class="clear-icon" *ngIf="searchControl.value" (click)="clearSearch()">close</mat-icon>
        </div>
        
        <button 
          mat-button
          class="filter-button custom-border-button custom-font-normal"
          [class.active]="hasActiveFilters()"
          (click)="filterSidenav.toggle()"
        >
          {{ 'request_v2.filter.button' | translate }}
          <span *ngIf="activeFilterCount() > 0" class="filter-count-badge">{{ activeFilterCount() }}</span>
        </button>
        
        <!--
         <app-export-menu (exportRequested)="exportAs($event)"></app-export-menu>
         -->
        <button
          class="create-request-button"
          (click)="openCreateRequestDialog()"
          [attr.aria-label]="'request_v2.list.aria_create_request' | translate"
        >
          {{ 'request_v2.list.create_request' | translate }}
        </button>
      </div>
    </div>

    <div class="content-container">
      <div class="map-container" *ngIf="activeView === 'map'">
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
          integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
          crossorigin=""
        />
        <div id="request-map"></div>
      </div>

      <div class="requests-content">
        <div *ngIf="loading" class="loading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <p>{{ 'request_v2.list.loading' | translate }}</p>
        </div>

        <div *ngIf="!loading && filteredRequests.length === 0" class="no-requests">
          <ng-container *ngIf="hasActiveFilters(); else noData">
            <h2>{{ 'request_v2.list.no_results_found' | translate }}</h2>
            <p>{{ 'request_v2.list.try_adjusting_filters' | translate }}</p>
            <button class="clear-filters-button" (click)="clearAllFilters()">
              {{ 'request_v2.list.clear_filters' | translate }}
            </button>
          </ng-container>
          <ng-template #noData>
            <h2>{{ 'request_v2.list.no_requests' | translate }}</h2>
            <p>{{ 'request_v2.list.create_first_request' | translate }}</p>
          </ng-template>
        </div>

        <div *ngIf="!loading && filteredRequests.length > 0" class="requests-table">
            <div class="request-title-container">
              <span class="request-title">{{ 'request_v2.list.request_list' | translate }}</span>
              <span class="request-count">{{ filteredRequests.length }}</span>
              <!--
                <button class="add-button" (click)="openCreateRequestDialog()" [attr.aria-label]="'request_v2.list.aria_add_request' | translate">+</button>
              -->
            </div>
          <table style="position: relative; z-index: 1;">
            <thead style="border-top: 1px solid #dddddd; border-bottom: 1px solid #dddddd;">
              <tr>
                <th *ngFor="let header of columnHeaders" 
                    style="vertical-align: middle;"
                    [class.sortable]="header.sortable"
                    (click)="sort(header)">
                  <div class="header-content">
                    {{ header.translationKey | translate }}
                    <span *ngIf="header.sortable" class="sort-icon">
                      <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">
                        {{ filters.sortBy !== header.sortField ? 'unfold_more' : (filters.sortOrder === 'asc' ? 'arrow_drop_up' : 'arrow_drop_down') }}
                      </mat-icon>
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let request of filteredRequests" 
                  [class.expanded]="request.expanded" 
                  (click)="openRequestDetail(request)"
                  class="request-row">
                <td class="subject-cell">
                  <div class="subject-with-icon">
                    <div class="unread-indicator-container">
                      <span 
                        class="unread-message-dot" 
                        *ngIf="request.adminUnreadMessageCount > 0"
                        [matTooltip]="'request_v2.info-dialog.messages.new_message_tooltip' | translate">
                      </span>
                    </div>
                    <div class="category-icon" [ngStyle]="{
                      'background-color': getMarkerBackgroundColor(request.category.color),
                      'border': '1px solid ' + request.category.color
                    }">
                    <i [ngClass]="request.category.icon" class="subject-icon"  [ngStyle]="{'color': request.category.color}"></i>

                    </div>
                    <div class="subject-info">
                      <div class="subject-select-container">
                        <div class="subject-select-trigger list-variant">
                          <span class="subject-name-display">{{ request.subCategory?.name ?? ('request_v2.subject.select_a_subject_placeholder' | translate) }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="category-cell">{{ request.category.name }}</td>
                <td class="request-id-cell">{{ request.requestId }}</td>
                <td class="location-cell">
                  <div class="location-wrapper">
                    <span>{{ request.location || ('request_v2.list.no_location' | translate) }}</span>
                    <mat-icon *ngIf="request.coordinates" class="location-pin-icon" 
                       [attr.title]="'request_v2.list.location_tooltip' | translate" style="font-size: 16px; height: 16px; width: 16px;">location_on</mat-icon>
                  </div>
                </td>
                <td class="date-cell">{{ request.createdAt | date:'longDate':undefined:currentLocale }}</td>
                <td class="status-cell">
                  <app-status-select 
                    *ngIf="request.status" 
                    [currentStatus]="request.status"
                    [statuses]="request.categoryStatuses"
                    [requestId]="request._id"
                    (statusChange)="onStatusChange($event)"
                    (click)="$event.stopPropagation()"
                  ></app-status-select>
                </td>
                <td class="department-cell">
                  <div *ngIf="request.department" class="department-badge">
                    <div class="department-select-container">
                      <div class="department-badge" [ngStyle]="{
                          'background-color': getChipBackgroundColor(request.department.color),
                          'color': '#000000'
                        }">
                        <span class="department-text">{{ request.department.name | titlecase }}</span>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="!request.department" class="department-badge">
                    <div class="department-select-container">
                      <div class="department-badge" [ngStyle]="{
                          'background-color': '#F0F0F0',
                          'color': '#000000'
                        }">
                        <span class="department-text">{{ 'request_v2.list.unassigned' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="tags-cell">
                  <div class="tags-container" *ngIf="request.tags?.length">
                    <span class="tag-badge" *ngFor="let tag of request.tags | slice:0:3">{{ tag }}</span>
                    <span class="tag-more" *ngIf="request.tags.length > 3">+{{ request.tags.length - 3 }}</span>
                  </div>
                </td>
                <td class="reporter-cell">
                  <div class="reporter-container" *ngIf="request.reporter">
                    <div  class="user-avatar">
                      <img *ngIf="request.reporter.picture" [src]="request.reporter.picture" alt="User avatar">
                      <span *ngIf="!request.reporter.picture">{{ getInitials((request.reporter.firstName || '') + ' ' + (request.reporter.lastName || '')) }}</span>
                    </div>
                    <span class="reporter-name">{{ request.reporter.firstName || '' }} {{ request.reporter.lastName || '' }}</span>
                  </div>
                  <div class="reporter-container" *ngIf="!request.reporter">
                    <span class="reporter-name">-</span>
                  </div>
                </td>
                <td class="sla-cell">
                  <div class="sla-dates">
                    <div class="sla-date-single" *ngIf="request.expectedEnd">
                      {{ request.expectedEnd | date:'longDate':undefined:currentLocale }}
                    </div>
                    <div class="sla-tbd" *ngIf="!request.expectedEnd">
                      {{ 'request_v2.list.tbd' | translate }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- Pagination -->
        <mat-paginator *ngIf="!loading && filteredRequests.length > 0"
                       [length]="length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       [pageIndex]="pageIndex"
                       (page)="pageChange($event)"
                       showFirstLastButtons
                       >
        </mat-paginator>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<router-outlet></router-outlet>
